module.exports = __webpack_public_path__ + "static/media/payment-processing.f0d73d38.gif";